import { Tooltip } from '@mantine/core';
import { RichTextEditor, useRichTextEditorContext } from '@mantine/tiptap';
import { IconUnderline } from '@tabler/icons-react';

/**
 * Used to underline text.
 */
export default function ControlUnderline() {
  const { editor } = useRichTextEditorContext();

  return (
    <Tooltip label="Underline" openDelay={300} closeDelay={50} withArrow={false}>
      <RichTextEditor.Control
        onClick={() => editor?.chain().focus().toggleUnderline().run()}
        active={editor?.isActive('underline')}
      >
        <IconUnderline size={20} />
      </RichTextEditor.Control>
    </Tooltip>
  );
}
